

import { useEffect, useState } from 'react'
import { getVotes, subscribe } from './store'
import type { Vote } from './types'

/** Live-updating votes list (Supabase Realtime emulation). */
export function useVotes(): Vote[] {
  const [votes, setVotes] = useState<Vote[]>(() => getVotes())

  useEffect(() => {
    setVotes(getVotes())
    return subscribe(() => setVotes(getVotes()))
  }, [])

  return votes
}


